import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class ParentPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.parentRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.parentImport,
    );
    this.parentAutocomplete = permissionChecker.match(
      Permissions.values.parentAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.parentCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.parentEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.parentDestroy,
    );
  }
}
